import translations from "@/translations";
import type { ITranslationProvider } from "@/interfaces/ITranslationProvider";

export class LocalTranslationProvider implements ITranslationProvider {
	private defaultLanguage = "en";

	getTranslation(
		errorIdentifier: string | number,
		language: string,
	): string | null {
		// If language doesn't exist, fall back to default language
		const langData =
			translations[language] || translations[this.defaultLanguage];

		if (!langData) {
			return null;
		}

		// Convert identifier to string for object property access
		const idStr = String(errorIdentifier);
		return langData[idStr] || null;
	}

	getAvailableLanguages(): string[] {
		return Object.keys(translations);
	}

	getDefaultLanguage(): string {
		return this.defaultLanguage;
	}
}
